module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/jdwx.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fjdwx.png
// module id = lHtg
// module chunks = 93